export const uniqueArray = (array: any[]) => array.filter(
  (obj, index, arr) =>
    arr.findIndex(item => JSON.stringify(item) === JSON.stringify(obj)) === index
);